export const MAX_IMAGE_WIDTH = 640;
export const ASPECT_RATIO_DEFAULT = 9 / 16;
